<template>
  <el-row class="media-tabs">
    <media-tab
      v-for="tabItem in tabs"
      style="overflow: hidden"
      :key="tabItem.value"
      class="media-tabs__tab"
      :is-active="selectedTab == tabItem.value"
      :has-remove-icon="tabItem.clearable"
      @selected="selectTab(tabItem.value)"
      @deleteAll="$emit('deleteAll', tabItem.value)"
    >
      {{ tabItem.label }}
    </media-tab>
  </el-row>
</template>

<script>
import MediaTab from "@/components/media/MediaTab.vue";

// @group Media
// Medias list
export default {
  name: "MediaTabsPanel",
  components: {
    MediaTab
  },
  model: {
    prop: "selectedTab",
    event: "selectTab"
  },
  props: {
    /** Selected tab id */
    selectedTab: {
      type: String,
      default: "clips"
    },
    /** All tabs list */
    tabs: {
      type: Array,
      default: () => [
        {
          value: "clips",
          label: "Clips",
          clearable: false
        },
        {
          value: "gifs",
          label: "GIFs",
          clearable: false
        },
        {
          value: "audios",
          label: "Audios",
          clearable: false
        },
        {
          value: "upload",
          clearable: false
        }
      ]
    }
  },
  methods: {
    // @vuese
    // Change selected tab
    selectTab(tab) {
      // User select tab
      this.$emit("selectTab", tab);
    }
  }
};
</script>

<style lang="scss" scoped>
.media-tabs {
  display: flex;

  &__tab {
    flex-grow: 1;
  }
}
</style>
